// src/context/OffersContext.js
import { createContext, useState } from "react";

export const OffersContext = createContext();

export const OffersProvider = ({ children }) => {
  const [tempPrices, setTempPrices] = useState({}); // { productId: offerPrice }

  const updateOfferPrice = (productId, price) => {
    setTempPrices((prev) => ({ ...prev, [productId]: price }));
  };

  const resetOfferPrice = (productId) => {
    setTempPrices((prev) => {
      const newState = { ...prev };
      delete newState[productId];
      return newState;
    });
  };

  return (
    <OffersContext.Provider
      value={{ tempPrices, updateOfferPrice, resetOfferPrice }}
    >
      {children}
    </OffersContext.Provider>
  );
};
